import React from "react";
import useForm, { Form } from "../../../hooks/useForm";
import Controls from "../controls/Controls";
import useAuth from "../../../hooks/useAuth";
import { login } from "../../../apis/auth.api";

const initialValue = {
  email: "",
  password: "",
  is_remember: false,
};

function LoginForm({ setOpenPopup, setCurrentUser }) {
  const { setAuth } = useAuth();
  const { values, handleInputChange } = useForm(initialValue);

  const handleLogin = (e) => {
    e.preventDefault();

    login(values, (result) => {
      setAuth(result);
      setOpenPopup(false);
      setCurrentUser({
        display_name: result.fullName,
        image: result.avatar,
      });
    });
  };
  return (
    <Form onSubmit={handleLogin}>
      <Controls.Input
        name="email"
        value={values.email}
        label="Email"
        type="email"
        onChange={handleInputChange}
      />
      <Controls.Input
        name="password"
        value={values.password}
        label="Password"
        type="password"
        onChange={handleInputChange}
      />

      <Controls.Button sx={{ width: "100%" }} type="submit" text="Login" />
    </Form>
  );
}

export default LoginForm;
